import { Children, useEffect, useRef, useState } from "react";
import { getRefValue } from "./Ref";
import './Accordian.scss';
export interface Props {
  title: [];
  content: [];
  isOpen: boolean;
  btnOnClick: () => void;
  children?: any;
   style?: React.CSSProperties;
  btnStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  btnClass?: string;
  contentClass?: string;
}
const SingleAccord = ({ title, content, isOpen, btnOnClick, children,style, btnStyle, contentStyle, btnClass, contentClass }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen) {
      const contentEl = getRefValue(contentRef);
      if (contentEl) {
        setHeight(contentEl.scrollHeight);
      }
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <li className={`accordion-item ${isOpen ? "active" : ""}`}>
      <h2 className="accordion-item-title">
        <button className={`accordion-item-btn ${btnClass && btnClass}`} style={btnStyle && btnStyle} id={title?.toString().replace(/ /g, '')} aria-controls={title?.toString().replace(/ /g, '')} onClick={btnOnClick} aria-expanded={isOpen ? 'true' : 'false'}>
          {title ? title : children}
        </button>
      </h2>
      <div
        className="accordion-item-container"
        style={{
          height: `${height}px`,
          overflow: isOpen ? "visible" : "hidden",
        }}
        id={title?.toString().replace(/ /g, '')}
        aria-labelledby={title?.toString().replace(/ /g, '')}
      >
        <div ref={contentRef} className={`accordion-item-content ${contentClass && contentClass}`} style={contentStyle && contentStyle} >
          {content ? content : children}
        </div>
      </div>
    </li>
  );
};

export default SingleAccord;
